/**
 * Create file in memory for user to download.
 */
export function saveData(
    filename: string,
    data: BlobPart,
    mimeType: string = "text/plain",
): void {
    const blob = new Blob([data], { type: mimeType });
    const element = window.document.createElement("a");
    element.href = window.URL.createObjectURL(blob);
    element.download = filename;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}
